<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, TimelineMax as Line, Power1, Power2 } from 'gsap'

export default {

  name: 'ScrollMarker',

  props: {
    label: {
      type: String,
      default () {
        return this.$t('scroll-deeper')
      }
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      standby: false,
      timeout: null
    }
  },

  methods: {
    onClick () {
      this.$emit('click')
    },

    beforeAppear (el) {
      this.$refs.label.style.transition = 'none'
      this.$refs.bar.style.transition = 'none'
      this.$refs.arrow.style.transition = 'none'
      this.$refs.arrowTip.style.transition = 'none'

      this.$refs.arrow.style.opacity = 1
      this.$refs.arrow.style.visibility = 'visible'
      this.$refs.arrow.style.transform = 'scale(1)'
      this.$refs.arrow.style.height = '0'

      this.$refs.arrowTip.style.opacity = 1
      this.$refs.arrowTip.style.visibility = 'visible'
    },

    enter (el, done, params = {}) {
      clearTimeout(this.timeout)

      const line = new Line({
        delay: params.delay || 0,
        onComplete: () => {
          if (this.$refs.bar) this.$refs.bar.removeAttribute('style')
          if (this.$refs.arrow) this.$refs.arrow.removeAttribute('style')
          if (this.$refs.arrowTip) this.$refs.arrowTip.removeAttribute('style')
          if (this.$refs.label) this.$refs.label.removeAttribute('style')

          this.timeout = setTimeout(() => {
            this.standby = true
            this.timeout = null
            clearTimeout(this.timeout)
          }, 100)

          done()
        }
      })

      line.fromTo(this.$refs.arrowTip, 0.25, {
        scale: 0,
        y: -12
      }, {
        scale: 1,
        delay: 0.25,
        ease: Power1.easeOut,
        onStart () {
          if (this.target) {
            this.target.style.transformOrigin = 'top'
          }
        }
      })

      line.fromTo(this.$refs.bar, 0.1, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: Power1.easeOut
      }, '+=0.2')

      line.add('before-slide')

      line.fromTo(this.$refs.bar, 0.35, {
        height: 0
      }, {
        height: 52,
        ease: Power1.easeOut
      }, 'before-slide')

      line.to(this.$refs.arrowTip, 0.35, {
        y: 40,
        ease: Power1.easeOut
      }, 'before-slide')

      line.fromTo(this.$refs.bar, 0.35, {
        y: -20
      }, {
        y: 0,
        ease: Power2.easeOut
      }, 'before-slide+=0.3')

      line.from(this.$refs.label, 0.4, {
        autoAlpha: 0,
        y: -10,
        scale: 1.2,
        ease: Power2.easeOut,
        onStart () {
          if (this.target) {
            this.target.style.transformOrigin = 'bottom'
          }
        }
      }, '-=0.2')
    },

    // enter (el, done) {
    //   this.standby = true

    //   Tween.from(el, 1, {
    //     autoAlpha: 0,
    //     ease: Power1.easeOut,
    //     onComplete: done
    //   })
    // },

    leave (el, done) {
      Tween.to(el, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

button.scroll-marker(
  type="button"
  :class="{ 'is-standby': standby, 'is-dark': darkMode }"
  @click="onClick")
  .scroll-marker__inner

    .label
      span.label__content(ref="label") {{ label }}

    .graphic
      .graphic-bar(ref="bar")
        .graphic-bar__point(ref="barPoint")
      .graphic-arrow(ref="arrow")
        .graphic-arrow__tip(ref="arrowTip")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

size = 4px
arrow-size = size * 1.25
arrow-offset = ((arrow-size * 2) - size) / 2px

.scroll-marker
  display block
  width 131px
  height 83px
  cursor pointer !important
  overflow hidden
  +tablet()
    display: none
  +mobile()
    display: none

  &__inner
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    display flex
    flex-direction column
    align-items center
    justify-content space-between
    pointer-events none

.label
  display flex
  align-items center
  height 46px

  &__content
    width 100%
    text-align center
    font-size 14px
    font-weight 500
    color white
    transition transform .2s

    .scroll-marker.is-standby:hover &
      transform translateY(8px)
      transition transform .4s

    .scroll-marker.is-dark &
      color blue

.graphic
  position relative
  display block
  width size
  height 32px

.graphic-bar
  z-index 1
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background-color orange
  transition transform .4s

  .scroll-marker.is-standby:hover &
    transform translateY(100%)
    transition transform .2s

  .scroll-marker.is-dark &
    background-color blue

  &__point
    position absolute
    top 0
    left 0
    display block
    width size
    height size
    background-color white

    .scroll-marker.is-standby:hover &
      opacity 0
      visibility hidden
      animation none

    .is-standby &
      animation standby 1s ease-in-out .5s alternate infinite

    .scroll-marker.is-dark &
      background-color orange

  @keyframes standby
    0%
      transform translateY(0px)
    30%
      transform translateY(0px)
    70%
      transform translateY(28px)
    100%
      transform translateY(28px)

.graphic-arrow
  z-index 2
  position absolute
  top -(size * 2)
  left 0
  display block
  width size
  height 12px
  background-color orange
  opacity 0
  visibility hidden
  transform-origin top
  transform translateY(0) scaleY(0)

  .scroll-marker.is-dark &
    background-color blue

  .is-standby &
    transition opacity .1s .1s,
               visibility .1s .1s,
               transform .2s

  .scroll-marker.is-standby:hover &
    opacity 1
    visibility visible
    transform translateY(8px) scaleY(1)
    transition opacity .1s,
               visibility .1s,
               transform .4s

  &__tip
    position absolute
    bottom -(arrow-size + 1)
    left -(arrow-offset)
    display block
    width 0
    height 0
    border-top (arrow-size + 1) solid orange
    border-left arrow-size solid transparent
    border-right arrow-size solid transparent

    .scroll-marker.is-dark &
      border-top (arrow-size + 1) solid blue

</style>



// WEBPACK FOOTER //
// scroll-marker.vue?9ed9b9ba